import React, {ReactElement, useEffect} from "react";
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {makeStyles} from '@mui/styles';
import {DefaultSizesDto, ItemsListMenuDto, UserDto} from "../../../../../../../dtos";
import {MenuItem, SubMenu} from "react-contextmenu";
import styles from './menuForPromotions.module.scss';
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {Box, Button, Typography, useMediaQuery} from "@mui/material";
import {ReactComponent as EditNoFillIcon} from "../../../../../../../assets/edit_no_fill_icon.svg";
import {ReactComponent as DeleteNoFillIcon} from "./../../../../../../../assets/xCircularIcons/delete_icon.svg";
import {ReactComponent as SettingIcon} from "./../../../../../../../assets/xCircularIcons/setting_icon.svg";
import {ReactComponent as UploadIcon} from "./../../../../../../../assets/flyersScreen/upload_icon.svg";
import {ReactComponent as ArchiveIcon} from "./../../../../../../../assets/flyersScreen/archive_icon.svg";
import {ReactComponent as RestoreIcon} from "./../../../../../../../assets/flyersScreen/restore_icon.svg";
import {ReactComponent as DeleteIcon} from "./../../../../../../../assets/flyersScreen/delete_icon.svg";
import {ReactComponent as DownloadIcon} from "./../../../../../../../assets/flyersScreen/donwload_pdf_icon.svg";
import {ReactComponent as InfoIcon} from "./../../../../../../../assets/flyersScreen/info.svg";
import LabelFileSelector from "../../../../../../../com/labelFileSelector/LabelFileSelector";
import {useDispatch} from "react-redux";
import {toggleFlyerRightPanel} from "../../../../../../../store/actionCreators/toggleActionForEditorActionCreators";


const useStyles = makeStyles(() => ({
    popper: {
        zIndex: 1062,
    },
    paper: {
        borderRadius: '5px',
        margin: '0 5px',
        border: '1px solid #B3B3B3'

    },
    list: {
        padding: 0,
        // marginTop: '5px'
    },
    root: {
        // fontSize: '14px',
        // height: '40px',
        justifyContent: 'space-between',
        "& > .MuiButton-root": {
            padding: "8px 12px!important",
            justifyContent: "flex-start",
            borderRadius: "0"
        }
    }

}));

interface Props {
    list: ItemsListMenuDto,
    makeUnlinkTargetPromo?: () => void;
    deleteUnlinkPromotionsFromFlyer?: (value: boolean) => void;
    linkUnlinkPromotionToFirstEmptyFrame?: () => void;
    isUnlinkPromo?: boolean;
    createNewPromotion?: VoidFunction;
    editFrame?: VoidFunction;
    isForFrame?: boolean;
    infoForMenu?: string;
    createNewItem?: (e: React.MouseEvent<HTMLElement>) => void;
    editPromotion?: (e: React.MouseEvent<HTMLElement>) => void;
    editTocCaption?: (e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => void;
    deleteTocCaption?: (e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => void;
    unlinkAllItemFromPromoSelectedPromo?: VoidFunction;
    isPromotionIncludeItems?: boolean;
    handleDeleteClick?: VoidFunction;
    archiveFlyer?: VoidFunction;
    isShowRightPanel?: boolean;
    isDisableEdit?: boolean;
    isDisableUpload?: boolean;
    onAddImageFilesToPages?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    editFlyerFromMobile?: VoidFunction;
    isDisableDelete?: boolean;
    isDisabledContextMenuOption?: boolean;
    selectedPageRange?: number;
    totalPagesInFlyer?: number;
    pageNumber?: number;
    insertAfterPageCallback?: VoidFunction;
    insertBeforePageCallback?: VoidFunction;
    optionForSelectPages?: ReactElement[];
    isShowInfoForPage?: boolean;
    pageWxH?: DefaultSizesDto;
    deletePages?: VoidFunction;
    movePageCallback?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    pageId?: number;
    onChangePageNUmber?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    downloadFlyer?: VoidFunction;
    deleteGui?: VoidFunction;
    editGui?: VoidFunction;
    deleteStoreSetting?: VoidFunction;
    editStoreSetting?: VoidFunction;
    setDefaultStoreSetting?: VoidFunction;
    handleDeleteRestoreClick?: (isDelete: boolean) => void;
    handleHardDeleteFlyer?: VoidFunction;
    handleRestoreFlyer?: VoidFunction;

    deleteUserAndPermission?: VoidFunction;
    editUserAndPermission?: VoidFunction;
    onSendEmailToUser?: VoidFunction;
}


export const MenuForPromotion = (props: Props) => {
    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let {isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto.accountTier === 1;
    const isMd = useMediaQuery(`(max-width:1199px)`);
    const classes = useStyles();

    const handleClose = (event: any) => {
        if (props.list.anchorRef.current && props.list.anchorRef.current.contains(event.target)) {
            return;
        }

        props.list.setOpen(false);
    };

    function handleListKeyDown(event: any) {
        if (event.key === 'Tab') {
            event.preventDefault();
            props.list.setOpen(false);
        }
    }

    useEffect(() => {
        if (props.list.prevOpen.current && !props.list.open) {
            props.list.anchorRef.current!.focus();
        }

        props.list.prevOpen.current = props.list.open;
    }, [props.list.open]);


    const unlinkPromo = (event: React.MouseEvent<HTMLElement>) => {
        handleClose(event);
        if (props?.makeUnlinkTargetPromo) {
            props?.makeUnlinkTargetPromo();
        }
    }

    const deletePromo = (event: React.MouseEvent<HTMLElement>) => {
        handleClose(event);
        if (props?.deleteUnlinkPromotionsFromFlyer) {
            props?.deleteUnlinkPromotionsFromFlyer(true);
        }
    }

    const linkUnlinkPromoToFirstEmptyFrame = (event: React.MouseEvent<HTMLElement>) => {
        handleClose(event);
        if (props?.linkUnlinkPromotionToFirstEmptyFrame) {
            props?.linkUnlinkPromotionToFirstEmptyFrame();
        }
    }

    const unlinkAllItemsFromPromotion = () => {
        if (props.unlinkAllItemFromPromoSelectedPromo) {
            props.unlinkAllItemFromPromoSelectedPromo()
        }
    }

    const editFlyer = (event: any) => {
        handleClose(event);
        if (!isMd) {
            dispatch(toggleFlyerRightPanel());
        } else {
            if (props.editFlyerFromMobile) {
                props.editFlyerFromMobile();
            }
        }
    }
    const onSoftDeleteArchivedFlyer = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (!props?.handleDeleteRestoreClick) {
            return;
        }
        props?.handleDeleteRestoreClick(true);
        handleClose(event);
    }
    const onRestoreArchivedFlyer = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (!props?.handleDeleteRestoreClick) {
            return;
        }
        props?.handleDeleteRestoreClick(false);
        handleClose(event);
    }

    const onHardDeleteDeletedFlyer = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (!props?.handleHardDeleteFlyer) {
            return;
        }
        props?.handleHardDeleteFlyer();
        handleClose(event);
    }
    const onRestoreDeletedFlyer = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (!props?.handleRestoreFlyer) {
            return;
        }
        props?.handleRestoreFlyer();
        handleClose(event);
    }

    const onArchiveDeletedFlyer = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (!props?.archiveFlyer) {
            return;
        }
        props?.archiveFlyer();
        handleClose(event);
    }


    return (
        <>
            <Popper
                open={props.list.open}
                anchorEl={props.list.anchorRef.current}
                role={undefined}
                transition
                placement={'right-start'}
                className={classes.popper}
                modifiers={{
                    preventOverflow: {
                        boundariesElement: "viewport"
                    }
                }}
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                    >
                        <Paper className={classes.paper}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={props.list.open} id="menu-list-grow"
                                          disablePadding
                                          onKeyDown={handleListKeyDown} className={classes.list}>
                                    {
                                        props.infoForMenu === 'menuForFrameWithPromo' &&
                                        <MenuItem className={classes.root} onClick={unlinkPromo}>
                                            <button className={styles.option}
                                                    disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>Unlink
                                                Promotion
                                            </button>
                                        </MenuItem>
                                    }
                                    {
                                        props.infoForMenu === 'menuForFlyerArchive' &&
                                        <Box>
                                            <MenuItem className={classes.root}>
                                                <Button
                                                    onClick={onSoftDeleteArchivedFlyer}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <DeleteIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                            >
                                                <Button
                                                    onClick={onRestoreArchivedFlyer}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px",
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <RestoreIcon/>
                                                    <Typography
                                                        color={"#000000"}
                                                        sx={{pointerEvents: "none"}}
                                                    >
                                                        Restore
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForFlyerDelete' &&
                                        <Box>
                                            <MenuItem className={classes.root}>
                                                <Button
                                                    onClick={onArchiveDeletedFlyer}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <ArchiveIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Archive
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    onClick={onHardDeleteDeletedFlyer}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <DeleteIcon/>

                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete Permanently
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                            >
                                                <Button
                                                    onClick={onRestoreDeletedFlyer}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px",
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <RestoreIcon/>
                                                    <Typography
                                                        color={"#000000"}
                                                        sx={{pointerEvents: "none"}}
                                                    >
                                                        Restore
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForPromo' &&
                                        <Box>
                                            <MenuItem className={classes.root}>
                                                <button className={styles.option} onClick={props.editPromotion}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Edit Promotion...
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button className={styles.option} onClick={props.createNewItem}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Add New Item...
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root} onClick={unlinkPromo}>
                                                <button className={styles.option}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>Unlink
                                                    Promotion
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root} onClick={unlinkAllItemsFromPromotion}>
                                                <button className={styles.option}
                                                        disabled={!props.isPromotionIncludeItems || flyerDetailsState.flyFstRec.fstCaption === "Published"}>Unlink
                                                    all Items
                                                </button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForEmptyFrame' &&
                                        <MenuItem className={classes.root}>
                                            <button className={styles.option} onClick={props.createNewPromotion}
                                                    disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>Add
                                                new
                                                Promotion
                                            </button>
                                        </MenuItem>
                                    }
                                    {
                                        props.infoForMenu === 'menuForUnlinkedPromo' &&
                                        <Box>
                                            <MenuItem className={classes.root}>
                                                <button
                                                    disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}
                                                    className={styles.option} onClick={props.createNewPromotion}>Add
                                                    new
                                                    Promotion...
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button className={styles.option} onClick={props.editPromotion}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Edit Promotion
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      onClick={linkUnlinkPromoToFirstEmptyFrame}
                                            >
                                                <button className={styles.option}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>
                                                    Link Promotion to next Empty Frame
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}>
                                                <button className={styles.option} disabled={true}>Duplicate Promotion
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root} onClick={deletePromo}>
                                                <button className={styles.option}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>Delete
                                                    Promotion
                                                </button>
                                            </MenuItem>
                                            <MenuItem className={classes.root} onClick={unlinkAllItemsFromPromotion}>
                                                <button className={styles.option}
                                                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}>Unlink
                                                    all Items
                                                </button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForPageToC' &&
                                        <Box>
                                            <MenuItem className={classes.root} onClick={props.editTocCaption}>
                                                <Button
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <EditNoFillIcon/>
                                                    <Typography color={"#000000"}>Edit</Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root} onClick={props.deleteTocCaption}
                                            >
                                                <Button
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        height: "40px",
                                                        "& > svg > path": {
                                                            fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DeleteNoFillIcon/>
                                                    <Typography color={"#000000"}>Delete</Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForFlyer' &&
                                        <Box>
                                            <MenuItem className={classes.root}
                                                      disabled={isAccountTier1 ? (isShowRightPanel && !isMd) : isShowRightPanel || isMd}
                                                      onClick={editFlyer}
                                            >
                                                <Button
                                                    disabled={isAccountTier1 ? (isShowRightPanel && !isMd) : isShowRightPanel || isMd}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    {isAccountTier1 && isMd ?
                                                        <EditNoFillIcon/> : <InfoIcon/>}
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        {isAccountTier1 && isMd ? "Edit" : "View Flyer Info"}
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          props.downloadFlyer!();
                                                      }}
                                                // disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    // disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DownloadIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Download Flyer in PDF
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <LabelFileSelector
                                                multiple={true}
                                                accept={".jpg, application/pdf"}
                                                fileId="flyer_page_data"
                                                onChange={(event) => {
                                                    if (props.onAddImageFilesToPages) {
                                                        props.onAddImageFilesToPages(event);
                                                        handleClose(event);
                                                    }
                                                }}
                                                isDisabled={props.isDisableUpload || props.isDisableDelete}
                                            >
                                                <Box
                                                    sx={{
                                                        padding: "8px 12px!important",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        // height: "40px",
                                                        opacity: props.isDisableUpload || props.isDisableDelete ? "0.5" : "1",
                                                        pointerEvents: props.isDisableUpload || props.isDisableDelete ? "none" : "auto",
                                                        "& > svg > path": {
                                                            fill: "#000000"
                                                        }
                                                    }}

                                                    className={`${styles.option} menuOption`}
                                                >
                                                    <UploadIcon/>
                                                    <Typography
                                                        color={"#000000"}
                                                        sx={{pointerEvents: "none"}}
                                                    >
                                                        Upload Pages Images
                                                    </Typography>
                                                </Box>
                                            </LabelFileSelector>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          props.archiveFlyer!();
                                                      }}
                                                      disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <ArchiveIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Archive
                                                    </Typography>
                                                </Button>
                                            </MenuItem>

                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          props.handleDeleteClick!();
                                                      }}
                                                      disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            // fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DeleteIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForPage' &&
                                        <Box>
                                            {
                                                props.isShowInfoForPage && props.pageWxH &&
                                                <MenuItem
                                                    disabled={true}
                                                    className={classes.root}>
                                                    <Box
                                                        sx={{
                                                            padding: "8px 12px!important",
                                                            flexFlow: "row",
                                                            columnGap: "10px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            opacity: "none",
                                                            cursor: "default"
                                                        }}
                                                        className={`${styles.option} ${styles.noneHover}`}
                                                    >
                                                        <InfoIcon/>
                                                        <Typography color={"#000000"}
                                                                    sx={{pointerEvents: "none"}}>
                                                            Page size: {props.pageWxH.width}x{props.pageWxH.height}px
                                                        </Typography>
                                                    </Box>
                                                </MenuItem>
                                            }
                                            <MenuItem
                                                // disabled={props.isDisabledContextMenuOption}
                                                className={classes.root}
                                                onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                    handleClose(event);
                                                    console.log(event);
                                                }}>
                                                <LabelFileSelector
                                                    multiple={false}
                                                    accept={".jpg"}
                                                    fileId={props.pageId?.toString() || ""}
                                                    onChange={props.onChangePageNUmber}
                                                    isDisabled={props.isDisabledContextMenuOption}
                                                >
                                                    <Box
                                                        sx={{
                                                            padding: "8px 12px!important",
                                                            flexFlow: "row",
                                                            columnGap: "10px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            opacity: props.isDisabledContextMenuOption ? "0.5" : "1",
                                                            pointerEvents: props.isDisabledContextMenuOption ? "none" : "auto",
                                                        }}
                                                        className={styles.option}
                                                    >
                                                        <UploadIcon/>
                                                        <Typography
                                                            color={"#000000"}
                                                            sx={{pointerEvents: "none"}}
                                                        >
                                                            Upload Page Image...
                                                        </Typography>
                                                    </Box>
                                                </LabelFileSelector>
                                            </MenuItem>
                                            <MenuItem
                                                disabled={props.isDisabledContextMenuOption}
                                                className={classes.root}
                                                onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                    if (props.insertBeforePageCallback) {
                                                        props.insertBeforePageCallback()
                                                        handleClose(event);
                                                    }
                                                }}>
                                                <Button
                                                    className={styles.option}
                                                    disabled={props.isDisabledContextMenuOption}
                                                >
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Insert Page to the Left
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem
                                                disabled={props.isDisabledContextMenuOption}
                                                className={classes.root}
                                                onClick={(event) => {
                                                    if (props.insertAfterPageCallback) {
                                                        props.insertAfterPageCallback();
                                                        handleClose(event);
                                                    }
                                                }}>
                                                <Button
                                                    className={styles.option}
                                                    disabled={props.isDisabledContextMenuOption}
                                                >
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Insert Page to the Right
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <SubMenu
                                                disabled={props.isDisabledContextMenuOption}
                                                className={styles.option}
                                                title={<Typography
                                                    color={"#000000"}
                                                    sx={{
                                                        pointerEvents: "none",
                                                        opacity: props.isDisabledContextMenuOption ? "0.5" : "1"
                                                    }}
                                                >
                                                    Move Page before...
                                                </Typography>}>
                                                <MenuItem
                                                    disabled={props.isDisabledContextMenuOption}
                                                    className={classes.root}
                                                    preventClose={true}
                                                >
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        // height: '60px',
                                                        justifyContent: 'space-around',
                                                        width: '170px',

                                                        // "& > div": {
                                                        //     marginLeft: '15px',
                                                        // },

                                                        '& > input': {
                                                            height: '40px',
                                                            width: '72px',
                                                            border: '1px solid #D1D7DB',
                                                            boxSizing: 'border-box',
                                                            borderRadius: '5px',
                                                            marginRight: '5px',
                                                        },

                                                        '& > select': {
                                                            height: '40px',
                                                            minWidth: '72px',
                                                            border: '1px solid #D1D7DB',
                                                            boxSizing: 'border-box',
                                                            borderRadius: '5px',
                                                            marginRight: '5px',
                                                            padding: '0 12px',
                                                            // textAlign: "center",
                                                            // "&::-webkit-scrollbar": {
                                                            //     width: "8px",
                                                            // },
                                                            //
                                                            // "&::-webkit-scrollbar-thumb": {
                                                            //     background: "lightgray",
                                                            //     borderRadius: "6px",
                                                            //     minHeight: "40px",
                                                            // },
                                                            //
                                                            //
                                                            // "&::-ms-expand": {
                                                            //     display: "none",
                                                            // },

                                                            '& > option:disabled': {
                                                                backgroundColor: "#9F9F9F",
                                                                padding: "0",
                                                                // margin: "2px 2px",
                                                            }
                                                        },
                                                    }}>
                                                        <Typography color={"#000000"}
                                                                    sx={{pointerEvents: "none"}}>
                                                            Page Number:
                                                        </Typography>
                                                        <select
                                                            onChange={(e) => {
                                                                if (props.movePageCallback) {
                                                                    props.movePageCallback(e);
                                                                    handleClose(e);
                                                                }
                                                            }}
                                                            value={props.pageNumber}
                                                        >
                                                            {props.optionForSelectPages}
                                                        </select>
                                                    </Box>
                                                </MenuItem>
                                            </SubMenu>
                                            <MenuItem
                                                disabled={props.totalPagesInFlyer === 1 || flyerDetailsState.flyFstRec.fstCaption === "Published"}
                                                className={classes.root}
                                                onClick={(e) => {
                                                    if (props.deletePages) {
                                                        props.deletePages();
                                                        handleClose(e);
                                                    }
                                                }}>
                                                {
                                                    props.selectedPageRange &&
                                                    <Button
                                                        disabled={props.totalPagesInFlyer === 1 || flyerDetailsState.flyFstRec.fstCaption === "Published"}
                                                        sx={{
                                                            padding: "8px 12px!important",
                                                            flexFlow: "row",
                                                            columnGap: "10px",
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                        className={styles.option}
                                                    >
                                                        <DeleteIcon/>
                                                        <Typography color={"#000000"}
                                                                    sx={{pointerEvents: "none"}}>
                                                            {props.selectedPageRange > 1 ? 'Delete Pages' : 'Delete Page'}
                                                        </Typography>
                                                    </Button>
                                                }
                                            </MenuItem>
                                        </Box>
                                    }

                                    {
                                        props.infoForMenu === 'menuForGui' &&
                                        <Box>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.editGui) {
                                                              return;
                                                          }
                                                          props.editGui();
                                                      }}
                                            >
                                                <Button
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <EditNoFillIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Edit
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.deleteGui) {
                                                              return;
                                                          }
                                                          props.deleteGui();
                                                      }}
                                                      disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            // fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DeleteIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }
                                    {
                                        props.infoForMenu === 'menuForStoreSetting' &&
                                        <Box>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.editStoreSetting) {
                                                              return;
                                                          }
                                                          props.editStoreSetting();
                                                      }}
                                            >
                                                <Button
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <EditNoFillIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Edit
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.deleteStoreSetting) {
                                                              return;
                                                          }
                                                          props.deleteStoreSetting();
                                                      }}
                                                      disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            // fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DeleteIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      disabled={props.isDisabledContextMenuOption}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.setDefaultStoreSetting) {
                                                              return;
                                                          }
                                                          props.setDefaultStoreSetting();
                                                      }}
                                            >
                                                <Button
                                                    disabled={props.isDisabledContextMenuOption}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            // fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <SettingIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Set as Default
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                        </Box>
                                    }

                                    {
                                        props.infoForMenu === "menuForUserAndPermission" &&
                                        <Box>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.editUserAndPermission) {
                                                              return;
                                                          }
                                                          props.editUserAndPermission();
                                                      }}
                                            >
                                                <Button
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px"
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.editTocCaption}
                                                >
                                                    <EditNoFillIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Edit
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            <MenuItem className={classes.root}
                                                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                          handleClose(event);
                                                          if (!props.deleteUserAndPermission) {
                                                              return;
                                                          }
                                                          props.deleteUserAndPermission();
                                                      }}
                                                      disabled={props.isDisableDelete}
                                            >
                                                <Button
                                                    disabled={props.isDisableDelete}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexFlow: "row",
                                                        columnGap: "10px",
                                                        justifyContent: "flex-start",
                                                        padding: "4px",
                                                        // height: "100%",
                                                        borderRadius: "0",
                                                        // height: "40px",
                                                        "& > svg > path": {
                                                            // fill: "#000000"
                                                        }
                                                    }}
                                                    className={styles.option}
                                                    // onTouchEnd={props.deleteTocCaption}
                                                >
                                                    <DeleteIcon/>
                                                    <Typography color={"#000000"}
                                                                sx={{pointerEvents: "none"}}>
                                                        Delete
                                                    </Typography>
                                                </Button>
                                            </MenuItem>
                                            {/*<MenuItem className={classes.root}*/}
                                            {/*          onClick={(event: React.MouseEvent<HTMLElement>) => {*/}
                                            {/*              handleClose(event);*/}
                                            {/*              if (!props.onSendEmailToUser) {*/}
                                            {/*                  return;*/}
                                            {/*              }*/}
                                            {/*              props.onSendEmailToUser();*/}
                                            {/*          }}*/}
                                            {/*>*/}
                                            {/*    <Button*/}
                                            {/*        title={"Email invite to register"}*/}
                                            {/*        disabled*/}
                                            {/*        sx={{*/}
                                            {/*            display: "flex",*/}
                                            {/*            alignItems: "center",*/}
                                            {/*            flexFlow: "row",*/}
                                            {/*            columnGap: "10px",*/}
                                            {/*            justifyContent: "flex-start",*/}
                                            {/*            padding: "4px",*/}
                                            {/*            // height: "100%",*/}
                                            {/*            borderRadius: "0",*/}
                                            {/*            // height: "40px"*/}
                                            {/*        }}*/}
                                            {/*        className={styles.option}*/}
                                            {/*        // onTouchEnd={props.editTocCaption}*/}
                                            {/*    >*/}
                                            {/*        <EmailIcon/>*/}
                                            {/*        <Typography color={"#000000"}*/}
                                            {/*                    sx={{pointerEvents: "none"}}>*/}
                                            {/*            Send Email*/}
                                            {/*        </Typography>*/}
                                            {/*    </Button>*/}
                                            {/*</MenuItem>*/}

                                        </Box>
                                    }
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}